// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__337Mt","label":"Completed_label__31Yx2"};